import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useNavigate } from 'react-router';

import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Switch, IconButton, TableFooter, TablePagination, Typography, Button, Grid, Dialog, DialogActions, DialogContent, TextField, CircularProgress, Paper } from '@mui/material'

import EditIcon from '@mui/icons-material/Edit';
import UndoIcon from '@mui/icons-material/Undo';

import { TablePaginationActions } from '../../helpers/TablePaginationActions';
import { usePages } from '../../hooks/usePages';
import { useFilter } from '../../hooks/useFilter';

import { RootState } from '../../store';
import { openSnackbar } from '../../store/slices/SnackbarSlice';

import { TablePaddingStyle, TableTheadStyle } from '../../styles/TableStyle';
import { DialogActionsStyle, DialogContentStyle } from '../../styles/DialogStyle';

import { Layout } from '../../components/Layout'
import { SearchTextField } from '../../components/SearchTextField';

import { ActualizarAutoridadExhortoRecibido, AgregarAutoridadExhorto, AutoridadExhortoRecibido } from '../../connections/catalogos/AutoridadExhortoRecibidoConnection';

import { AutoridadExhortoRecibidoProps } from '../../interfaces/catalogos/AutoridadExhortoRecibidoInterface';

export const AutoridadExhortoRecibidoPage = () => {

   const dispatch = useDispatch();

   const navigate = useNavigate();

    const { administrador, coordinador } = useSelector( ( state: RootState ) => state.auth );

    const [autoridadExhortoArray, setAutoridadExhortoArray] = useState<AutoridadExhortoRecibidoProps[]>( [] );

    const [openDialog, setOpenDialog] = useState( false );
    const [loading, setLoading] = useState( false );
    const [loadingData, setLoadingData] = useState( true );

    const [idAutoridadExhortoRecibido, setIdAutoridadExhortoRecibido] = useState( 0 );
    const [descripcion, setDescripcion] = useState( '' );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 5 );

    const { filtro, setFiltro, dataFiltrada } = useFilter( autoridadExhortoArray, ( item, filtro ) => item.descripcion?.toLowerCase().includes( filtro.toLowerCase() ) );

    const handleChangeChecked = async ( checked: boolean, id: number ) => {

        const estatusSelected = autoridadExhortoArray.find( ( elem ) => elem.idAutoridadExhortoRecibido === id );

        if ( estatusSelected ) {

            await ActualizarAutoridadExhortoRecibido({ ...estatusSelected, activo: checked }).then( resp => {

                if ( resp.idAutoridadExhortoRecibido ) {

                    var newArray = autoridadExhortoArray.map( ( elem ) => {

                        if ( elem.idAutoridadExhortoRecibido === id ) {
                            elem.activo = checked;
                        }

                        return elem;
                    });

                    setAutoridadExhortoArray( newArray );

                    dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));

                }

            });
        }

    }

    const handleGuardar = async () => {

        if ( idAutoridadExhortoRecibido !== 0 ) {

            const estatusSelected = autoridadExhortoArray.find( ( elem ) => elem.idAutoridadExhortoRecibido === idAutoridadExhortoRecibido );

            if ( estatusSelected ) {

                setLoading( true );

                await ActualizarAutoridadExhortoRecibido({ ...estatusSelected, descripcion, }).then( resp => {

                    if ( resp.idAutoridadExhortoRecibido ) {

                        setTimeout(() => {

                            var newArray = autoridadExhortoArray.map( ( elem ) => {

                                if ( elem.idAutoridadExhortoRecibido === idAutoridadExhortoRecibido ) {
                                    elem.descripcion = descripcion;
                                }

                                return elem;
                            });

                            setAutoridadExhortoArray( newArray );
                            setOpenDialog( false );
                            setLoading( false );

                            dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));

                        }, 700);

                    }

                });
            }

        } else {

            const AutoridadExhortoAdd: AutoridadExhortoRecibidoProps = {
                idAutoridadExhortoRecibido: 0,
                descripcion,
                activo: true,
            }

            setLoading( true );

            await AgregarAutoridadExhorto( AutoridadExhortoAdd ).then( resp => {

                if ( resp.idAutoridadExhortoRecibido ) {

                    setTimeout(() => {

                        setAutoridadExhortoArray([ ...autoridadExhortoArray, resp ]);
                        setOpenDialog( false );
                        setLoading( false );

                        dispatch( openSnackbar({ message: 'Se agregó la autoridad del exhorto recibido correctamente', variant: 'success' }));

                    }, 700);

                }

            });

        }

    }

    useEffect(() => {

        async function obtener() {

            setLoadingData( true );
            setAutoridadExhortoArray( [] );

            await AutoridadExhortoRecibido().then( resp => {

                setTimeout(() => {

                    setAutoridadExhortoArray( resp );
                    setLoadingData( false );

                }, 700);

            });

        }

        obtener();

    }, [ ])

    return (

        <Layout breadcrumbs={ [  { text: 'Administración' }, { text: 'Catálogos' }, { text: 'Autoridad de exhorto recibido' } ] } backgroundPaper={ false }>

            <Grid container spacing={ 3 }>

                <Grid size={{ xs: 6 }} textAlign={ 'start' }>

                    {
                        ( administrador || coordinador )
                        &&
                            <Button startIcon={ <UndoIcon /> } color='secondary' variant='text' sx={{ mt: 1 }} onClick={ () => navigate( '/' ) }>
                                Regresar
                            </Button>
                    }

                </Grid>

                <Grid size={{ xs: 6 }} textAlign={ 'end' }>

                    <Button
                        variant='contained'
                        sx={{ mt: 1 }}
                        disabled={ loadingData }
                        onClick={ () => {

                            setIdAutoridadExhortoRecibido( 0 );
                            setDescripcion( '' );

                            setOpenDialog( true );
                        }}
                    >
                        Agregar
                    </Button>

                </Grid>

            </Grid>

            <Grid container sx={{ mt: 2 }}>

                <Grid size={{ xs: 12 }}>

                    <SearchTextField
                        value={ filtro }
                        label='Buscar por descripción'
                        onChange={ ( value ) => {
                            setFiltro( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

            </Grid>

            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={ Paper }>

                <Table sx={{ minWidth: 500 }}>

                    <TableHead sx={{ ...TableTheadStyle }}>

                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'15%', textAlign: 'center' }}> Id </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'75%' }}> Descripción </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'10%' }}> </TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {
                            (
                                rowsPerPage > 0
                                ?
                                    dataFiltrada.slice( page * rowsPerPage, page * rowsPerPage + rowsPerPage )
                                :
                                    dataFiltrada
                            )
                            .map( ( { idAutoridadExhortoRecibido, descripcion, activo } ) => (

                                <TableRow key={ idAutoridadExhortoRecibido } >

                                    <TableCell sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                                        { idAutoridadExhortoRecibido }
                                    </TableCell>

                                    <TableCell>
                                        { descripcion }
                                    </TableCell>

                                    <TableCell sx={{ textAlign: 'end' }}>

                                        <Switch
                                            checked={ activo }
                                            onChange={ ( e ) => handleChangeChecked( e.target.checked, idAutoridadExhortoRecibido ) }
                                        />

                                        <IconButton
                                                color='primary'
                                                aria-label='edit'
                                                component='span'
                                                onClick={ () => {

                                                    setIdAutoridadExhortoRecibido( idAutoridadExhortoRecibido );
                                                    setDescripcion( descripcion );

                                                    setOpenDialog( true );
                                                }}
                                            >
                                            <EditIcon />
                                        </IconButton>

                                    </TableCell>

                                </TableRow>

                            ))
                        }

                        {
                            ( dataFiltrada.length === 0 && !loadingData )
                            ?
                                <TableRow style={{ height: 73 }}>

                                    <TableCell colSpan={ 7 } align='center'>

                                        <Typography variant='caption' color='secondary'> No se encontraron resultados </Typography>

                                    </TableCell>

                                </TableRow>
                            :
                                loadingData
                                &&
                                    <TableRow style={{ height: 73 }}>

                                        <TableCell colSpan={ 7 } align='center'>

                                            <CircularProgress size={ 32 } />

                                        </TableCell>

                                    </TableRow>
                        }

                    </TableBody>

                    <TableFooter>

                        {
                            dataFiltrada.length !== 0
                            &&
                                <TableRow>

                                    <TableCell colSpan={ 1 } sx={{ border: 'none' }}>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}>
                                            Total de registros: { dataFiltrada.length }
                                        </Typography>
                                    </TableCell>

                                    <TablePagination
                                        sx={{ border: 'none' }}
                                        rowsPerPageOptions={  [ 5, 10, 15, 25, 50, 75, 100, 150, 200, 500] }
                                        colSpan={ 2 }
                                        count={ dataFiltrada.length }
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }

                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }

                                        ActionsComponent={ TablePaginationActions }

                                        labelRowsPerPage='Filas por página'
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                            }
                                        }
                                    />

                                </TableRow>
                        }

                    </TableFooter>

                </Table>

            </TableContainer>

            <Dialog open={ openDialog } maxWidth='sm' fullWidth={ true }>

                <DialogContent sx={ DialogContentStyle }>

                    <TextField
                        sx={{ mt: 3 }}
                        label={ 'Descripción' }
                        variant='outlined'
                        multiline
                        rows={ 4 }
                        fullWidth
                        value={ descripcion }
                        onChange={ (e) => setDescripcion( e.target.value ) }
                        slotProps={{
                            input: {
                                autoComplete: 'off'
                            },
                            inputLabel: {
                                shrink: true,
                            }
                        }}
                    />

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button color='secondary' disabled={ loading } onClick={ () => setOpenDialog( false ) }> Cancelar </Button>
                    <Button loading={ loading } disabled={ descripcion === '' } onClick={ handleGuardar } variant='contained'> Guardar </Button>
                </DialogActions>

            </Dialog>

        </Layout>

    )
}
